import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const loginRedirectGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.areTokensValid()) {
    return true; // allow access to login/signup
  }

  // Redirect based on role
  if (authService.isAdmin()) {
    return router.parseUrl('/hospital/dashboard/admin');
  }

  if (authService.isStaff()) {
    return router.parseUrl('/hospital/dashboard/donor');
  }

  return router.parseUrl('/questionnaire'); // default for regular user
};
